import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {ApiBaseService, VendorsService} from '../../../../../../projects/vendors/src/public-api';
import { ApiEnum } from '../../../../@application/enum/api.enum';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-user-wise-order',
    templateUrl: './user-wise-order.component.html',
    styleUrl: './user-wise-order.component.scss',
    standalone: false
})
export class UserWiseOrderComponent implements OnInit, OnDestroy{

  userWiseOrders = [] as any[];
  apiBaseService = inject(ApiBaseService);
  vendorsService = inject(VendorsService);
  newOrderSubscription!: Subscription;

  ngOnInit(): void {
    this.dataSubscriptions();
    this.getData();
  }

  private dataSubscriptions() {
    this.newOrderSubscription = this.vendorsService.newOrderSubject.subscribe({
      next: newOrder => {
        if (newOrder)
          this.getData();
      }
    })
  }

  private getData() {
    this.apiBaseService.GET<any[]>([ApiEnum.RestaurantModule, ApiEnum.Order, ApiEnum.DashBoard, ApiEnum.CreatedByOrderCount])
      .subscribe({
        next: response => {
          this.userWiseOrders = response;
        }
      })
  }

  ngOnDestroy() {
    this.newOrderSubscription.unsubscribe();
  }

}
